import * as betgalaxy from './Footer.styles.betgalaxy';
import * as betprofessor from './Footer.styles.betprofessor';
import * as betroyale from './Footer.styles.betroyale';
import * as fiestabet from './Footer.styles.fiestabet';
import * as puntcity from './Footer.styles.puntcity';
import * as puntgenie from './Footer.styles.puntgenie';
import * as questbet from './Footer.styles.questbet';
import * as sterlingparker from './Footer.styles.sterlingparker';
import * as vikingbet from './Footer.styles.vikingbet';
import * as volcanobet from './Footer.styles.volcanobet';
import * as wellbet from './Footer.styles.wellbet';
import * as juicybet from './Footer.styles.juicybet';
import * as forsport from './Footer.styles.forsport';
import * as junglebet from './Footer.styles.junglebet';
import * as betstride from './Footer.styles.betstride';
import * as sugarcastle from './Footer.styles.sugarcastle';
import * as oldgill from './Footer.styles.oldgill';
import * as buffalobet from './Footer.styles.buffalobet';
import * as bet777 from './Footer.styles.bet777';
import * as goldenrush from './Footer.styles.goldenrush';
import * as titanbet from './Footer.styles.titanbet';
import * as slambet from './Footer.styles.slambet';
import * as templebet from './Footer.styles.templebet';
import * as gigabet from './Footer.styles.gigabet';
import * as goldenbet888 from './Footer.styles.goldenbet888';
import * as chromabet from './Footer.styles.chromabet';
import * as hyperbet from './Footer.styles.hyperbet';
import * as epicodds from './Footer.styles.epicodds';
import * as bet575 from './Footer.styles.bet575';
import * as magnumbet from './Footer.styles.magnumbet';
import * as pyramidbet from './Footer.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  bet777,
  goldenrush,
  titanbet,
  slambet,
  templebet,
  gigabet,
  goldenbet888,
  betstride,
  chromabet,
  hyperbet,
  epicodds,
  bet575,
  magnumbet,
  pyramidbet,
};
